// extracted by mini-css-extract-plugin
module.exports = {"container":"postDetailForm_container__2rx2g","form":"postDetailForm_form__15pFG","column":"postDetailForm_column__m4DGU"};